import React from "react";
import { ShareButtons } from "./ShareButtons";

/**
 * AuthorBlock — anchored at the foot of the article. The CMS doesn't store
 * a per-author field today, so this renders the Instabridge editorial team
 * as the publisher (which is also what we emit in the Article JSON-LD).
 */
export function AuthorBlock({ url, title, updatedAt }) {
  return (
    <aside
      className="not-prose mt-14 pt-10 border-t border-[#E5E7EB] flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8"
      data-testid="blog-author-block"
    >
      <div className="shrink-0 w-14 h-14 rounded-full bg-gradient-to-br from-[#0A2540] to-[#001A3D] text-white flex items-center justify-center font-display text-lg font-semibold">
        IB
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[11px] uppercase tracking-[0.14em] text-[#6B7280] font-semibold mb-1">
          Written by
        </div>
        <div className="font-display text-lg text-[#0A2540] font-semibold leading-tight">
          The Instabridge Funding Editorial Team
        </div>
        <p className="text-sm text-[#6B7280] mt-1.5 leading-relaxed max-w-2xl">
          Our editorial team works with licensed attorneys and pre-settlement
          funding specialists to publish guides that are accurate, current, and
          written in plain English — never legal jargon.
        </p>
        {updatedAt ? (
          <div className="mt-2 text-xs text-[#6B7280]">
            Last updated {updatedAt}
          </div>
        ) : null}
      </div>
      <div className="self-stretch sm:self-center">
        <div className="text-[11px] uppercase tracking-[0.14em] font-semibold text-[#6B7280] mb-2">
          Share
        </div>
        <ShareButtons url={url} title={title} />
      </div>
    </aside>
  );
}
